<template>
    <div>
        <div class="card-body text-center">
            <button @click="scheduleTrade()" class="btn btn-info" type="button">Schedule</button>
        </div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                Funds have been escrowed into a contract. Prepare delivery of the merchandise. When you are ready for shipping, please let the buyer know by clicking on Schedule button.
            </p>
        </div>
    </div>
</template>


<script>
    export default {
        name: "Schedule",
        props: {
            trade: Object,
            events: Object
        },
        data() {
            return {}
        },
        methods: {
            async scheduleTrade() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post('/trades/' + this.trade.trade_id + '/schedule', {comments: ''});
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'Shipment scheduled', 'Trade Scheduled');
                    this.events.$emit('trade:reload');
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                    this.$toastr('error', 'Schedule shipment failed', 'Failure');
                }
            }
        }
    }
</script>

<style scoped>

</style>
